import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";
import { kioskConfigurationHttp } from "./kiosk-configuration-http";
import { KioskConfiguration } from "../models/kiosk-configuration";

export const kioskConfigurationsCacheKeys = {
  kioskConfigurations: "kioskConfigurations",
  kioskConfiguration: "kioskConfiguration",
};

export const useListKioskConfigurations = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery<KioskConfiguration[], any>(
    [kioskConfigurationsCacheKeys.kioskConfigurations, organizationKeyName],
    () => kioskConfigurationHttp.getKioskConfigurations(organizationKeyName),
    { refetchOnWindowFocus: false }
  );
};

export const useDeleteKioskConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation(kioskConfigurationHttp.deleteKioskConfiguration, {
    onSuccess: async () => {
      await queryClient.refetchQueries(
        kioskConfigurationsCacheKeys.kioskConfigurations
      );
    },
  });
};

export const useUpdateKioskConfiguration = (id?: string) => {
  const queryClient = useQueryClient();

  return useMutation(kioskConfigurationHttp.updateKioskConfiguration, {
    onSuccess: async () => {
      await queryClient.refetchQueries(
        kioskConfigurationsCacheKeys.kioskConfigurations
      );
      if (id) {
        await queryClient.refetchQueries([
          kioskConfigurationsCacheKeys.kioskConfiguration,
          id,
        ]);
      }
    },
  });
};

export const useCreateKioskConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation(kioskConfigurationHttp.createKioskConfiguration, {
    onSuccess: async () => {
      await queryClient.refetchQueries(
        kioskConfigurationsCacheKeys.kioskConfigurations
      );
    },
  });
};

export const useUploadConfigImage = () => {
  return useMutation(kioskConfigurationHttp.uploadConfigImage);
};
